import request from 'superagent';
import B from 'bluebird';
import R from 'ramda';
import UserError from 'branch-node-core/branch/errors/UserError';

import {
  ORG_VIEW,
  AGENCY_VIEW,
  APP_VIEW_ID_FIELD,
  ORG_VIEW_ID_FIELD
} from '../../common/support/viewConstants';

const { view } = window.App.context;

const app_id = R.path([APP_VIEW_ID_FIELD], view);
const organization_id = R.path([ORG_VIEW_ID_FIELD], view);

const sendOrgIdHeader =
  view && (view.current_view === ORG_VIEW || view.current_view === AGENCY_VIEW);

export default function(name, data, files) {
  var promise = new B(function(resolve, reject) {
    var k,
      req = request
        .post(name)
        .set('X-Branch-Dashboard', 'dashboard')
        .set('x-csrf-token', window._csrfToken);

    if (sendOrgIdHeader) {
      req.set('x-organization-id', organization_id);
    } else {
      req.set('x-app-id', app_id);
    }

    if (files) {
      for (k in data) {
        if (data.hasOwnProperty(k)) {
          req = req.field(k, JSON.stringify(data[k]));
        }
      }

      for (k in files) {
        if (files.hasOwnProperty(k) && files[k] instanceof File) {
          req = req.attach(k, files[k], files[k].name);
        }
      }
    } else {
      req = req.send(data);
    }

    req.end(function(err, res) {
      if (err || !res.body) {
        if (err.status === 429) {
          return reject(
            new UserError(
              'Too many requests. If you have additional feedback, please submit tomorrow!'
            )
          );
        }
        return reject((err && err.message) || err);
      }
      if (res.body.status) {
        resolve(res.body.value);
      } else {
        reject(new UserError(res.body.message, res.body.field));
      }
    });
  });

  return promise;
}
